module.exports = __webpack_public_path__ + "img/1557614111289843714.774b4ce4.png";